import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { UserProfileEffects } from './store/user-profile.effects';
import * as fromUserProfile from './store/user-profile.reducer';
import { UserProfileService } from './user-profile.service';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature('users', fromUserProfile.reducer),
        EffectsModule.forFeature([UserProfileEffects])
    ],
    providers: [UserProfileService]
})
export class UserProfileModule {}
